import React from 'react';
import PropTypes from 'prop-types';

import level0 from '../../../../../img/signal/lev-0.png';
import level1 from '../../../../../img/signal/lev-1.png';
import level2 from '../../../../../img/signal/lev-2.png';
import level3 from '../../../../../img/signal/lev-3.png';
import level4 from '../../../../../img/signal/lev-4.png';
import level5 from '../../../../../img/signal/lev-5.png';

const SignalLevel = ({ level }) => {
	if (level === 1) {
		return <img src={level1} />;
	} else if (level === 2) {
		return <img src={level2} />;
	} else if (level === 3) {
		return <img src={level3} />;
	} else if (level === 4) {
		return <img src={level4} />;
	} else if (level === 5) {
		return <img src={level5} />;
	}
	return <img src={level0} />;
};

SignalLevel.propTypes = {
	level: PropTypes.number.isRequired,
};

export default SignalLevel;
